import "babel-polyfill";
import Vue from "vue";

import Cookies from "js-cookie";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import '../static/element-ui/index.css'

import "@/styles/index.scss"; // global css

import App from "./App";
import router from "./router";
import store from "./store";

import i18n from "./lang"; // Internationalization
import "./icons"; // icon
import "./errorLog"; // error log
import "./permission"; // permission control

import "vue-orgchart/dist/style.min.css"; // vue-orgchart 组织架构
import * as filters from "./filters"; // global filters

require("@/utils/workFlow/Injection");
import "vant/lib/index.css";
// import "vant/lib/index.less";
import "@/assets/workFlow/theme.scss";

// import "@/assets/workFlow/theme/index.css";
import "@/assets/workFlow/global.css";
import "@/assets/workFlow/iconfont/iconfont.css";

import Ellipsis from "@/components/workFlow/common/Ellipsis";
import WDialog from "@/components/workFlow/common/WDialog";
import Tip from "@/components/workFlow/common/Tip";

// 全局通用组件
import cmComponents from '@/components/examMan'
Vue.use(cmComponents)
Vue.prototype.$navBack = function() {
  window.history.back()
}
// 浮点计算
import calc from './utils/examMan/calc'
Vue.prototype.$calc = calc


// import Avatar from "@/components/workFlow/common/Avatar";
// import VueAMap from "vue-amap";
// Vue.use(VueAMap);
Vue.use(Ellipsis);
Vue.use(WDialog);
Vue.use(Tip);


import AMap from "vue-amap";
Vue.use(AMap);
AMap.initAMapApiLoader({
  key: "0a90a49e2535d363bccbdceff1b5dff6",
  uiVersion: "1.0",
  plugin: [
    "AMap.Autocomplete",
    "AMap.MouseTool",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",

    "AMap.ElasticMarker",

    "AMap.Geocoder",
    "AMap.Geolocation"
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: "1.4.4"
});
// Vue.use(Avatar);

// import FormMaking from "form-making";
// import "form-making/dist/FormMaking.css";

// Vue.use(FormMaking);

Vue.use(Element, {
  size: Cookies.get("size") || "medium", // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
});
store.dispatch("setLanguage", "zh");

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;



new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: h => h(App)
});
